/* eslint-disable @typescript-eslint/no-explicit-any */
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  constructor(private httpClient: HttpClient) {}

  async putEmployee(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.put<any>(enviroment.url + 'employee', element),
    );
  }

  async get_employee_plan(): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.get<any>(enviroment.url + 'plan/usuario'),
    );
  }

  async get_employee_cambio_plan(): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.get<any>(enviroment.url + '/cambio_plan/usuario'),
    );
  }

  async get_employee_bank_account(): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.get<any>(enviroment.url + '/usuario/cuentas_bancarias'),
    );
  }
}
